export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20white%20air%20conditioner%20unit%20mounted%20on%20light%20gray%20wall%20in%20bright%20contemporary%20living%20room%20interior%20with%20clean%20minimalist%20design%20soft%20natural%20lighting%20professional%20installation%20high%20quality%20residential%20cooling%20system&width=1920&height=1080&seq=hero-ac-001&orientation=landscape"
          alt="Modern Air Conditioning"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A2B4A]/40 via-[#1A2B4A]/30 to-[#1A2B4A]/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="max-w-3xl">
          {/* Label */}
          <div className="inline-flex items-center gap-2 bg-[#00A3E0] text-white px-5 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-time-line"></i>
            SERVIZIO 24/7 • RAVENNA E PROVINCIA
          </div>

          {/* Title */}
          <h1 className="text-white font-bold text-6xl lg:text-7xl leading-tight mb-6">
            Climatizzatori 24h<br />
            Ravenna e Dintorni
          </h1>

          {/* Subtitle */}
          <p className="text-white/90 text-xl leading-relaxed mb-10 max-w-2xl">
            Installazione, manutenzione e riparazione climatizzatori a Ravenna e provincia – servizio rapido 24h
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <a
              href="tel:+393806328251"
              className="inline-flex items-center gap-3 bg-[#FF6B35] text-white px-8 py-4 rounded-full font-bold text-base hover:bg-[#FF5722] transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-xl"></i>
              Chiama Ora +39 380 632 8251
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}